export default __webpack_public_path__ + "static/media/EAST1030.34I-34172_-18420_0.230e1bf8.jpg";